module.exports = __webpack_public_path__ + "static/media/tap_icon.b28170f0.svg";